import { ReactNode } from "react";
import { Routes } from "react-router-dom";

interface IProtectedRouterProps {
  isAccessAllowed: boolean;
  protectedRoutes: ReactNode;
  unprotectedRoutes?: ReactNode;
}

export const ProtectedRouter = (props: IProtectedRouterProps) => {
  const {
    isAccessAllowed,
    protectedRoutes,
    unprotectedRoutes
  } = props;

  return (
    <Routes>
      {isAccessAllowed ? protectedRoutes : unprotectedRoutes}
    </Routes>
  )
};
